import { ERROR_TYPES, createAuthService } from '@maple-tech/auth';
import { redirect } from 'react-router-dom';

const KnownHosts = import.meta.env;

const apiList = new Map([
  ['ModulesAPI', KnownHosts.VITE_Modules],
  ['CoreAPI', KnownHosts.VITE_Core],
  ['CoreAPIV2', KnownHosts.VITE_Core_V2],
  ['RetailAPI', KnownHosts.VITE_Retail],
  ['RetailAPIV2', KnownHosts.VITE_Retail_V2],
  ['DocumentsAPI', KnownHosts.VITE_Documents_V2],
  ['DocumentsAPIV2', KnownHosts.VITE_Documents_V2],
  ['AutomatorsAPI', KnownHosts.VITE_Automator],
  ['AuthAPI', KnownHosts.VITE_AUTH],
  ['TaskAPI', KnownHosts.VITE_Task],
  ['VMAPI', KnownHosts.VITE_VM],
]);

// Create Service
export const authService = createAuthService({
  storage: {
    get: (key: string): string | null => {
      return localStorage.getItem(key);
    },
    getAll: (): string[][] => {
      return Object.entries(localStorage);
    },
    del: (key: string): string => {
      const deletedValue = localStorage.getItem(key);
      if (!deletedValue) return '';
      localStorage.removeItem(key);
      return deletedValue || '';
    },
    set: (key: string, value: string): void => {
      localStorage.setItem(key, value);
    },
    clearAll: (): void => {
      localStorage.clear();
      redirect('/login');
    },
  },
  onError: (
    error: ERROR_TYPES,
    ...args: (string | number | boolean | Date)[]
  ) => {
    console.warn('onError', error, args);
  },
  onLoginSuccess: () => {
    console.info('onLoginSuccess');
    if (window.location.pathname === '/login') {
      redirect('/');
    }
  },
  onAuthLogout: () => {
    console.info('onAuthLogout');
    localStorage.clear();
    if (window.location.pathname != '/login') {
      redirect('/login');
    }
  },
  onSessionExpired: () => {
    console.info('onSessionExpired');
    localStorage.clear();
    if (window.location.pathname != '/login') {
      redirect('/login');
    }
  },
  userStorageKey: '@maple/userData',
  apisRegistry: apiList,
});
